
var React = require("react");
var ApplicationContext = require("../config/ApplicationContext.js");
var Utilities =          require("../util/Utilities.js");

class Footer extends React.Component {
    /**
        the block footer-nav__logo__eagle and footer-nav__social just appear if the user is on the page home
     */

    sendGoogleGA(type){
        googleGA("send", "event", Utilities.getPath(), type);
    }

    render() {
        let typeClass = this.props.type === "home" ? "home": "page";
        let prefix = ApplicationContext.assetUrlPrefix;

        return (
            <footer className="footer">
                <div className="container">
                    <ul className={`footer-nav ${typeClass}`}>
                        <li className="footer-nav__logo">
                            <a href="http://autodesk.com" onClick={() => this.sendGoogleGA("goAutodesk")} target="_blank">
                                <img src="https://s3-us-west-1.amazonaws.com/123d-circuits-assets/Footer-Autodesk.png" />
                            </a>
                        </li>
                        <li className="footer-nav__social">
                            <p>Follow us:</p>
                            <a href="https://www.twitter.com/adskeagle" onClick={() => this.sendGoogleGA("twitter")} target="_blank"><img className="footer-nav__social__icon" src={`${prefix}/assets/social/twitter.svg`}/></a>
                            <a href="https://www.facebook.com/AutodeskEAGLE" onClick={() => this.sendGoogleGA("facebook")} target="_blank"><img className="footer-nav__social__icon" src={`${prefix}/assets/social/facebook.svg`}/></a>
                            <a href="https://www.youtube.com/channel/UCjPWeOcXkMIOA_bd4LbivGg" onClick={() => this.sendGoogleGA("youtube")} target="_blank"><img className="footer-nav__social__icon" src={`${prefix}/assets/social/youtube.svg`}/></a>
                            <a href="https://www.autodesk.com/products/eagle/blog/" onClick={() => this.sendGoogleGA("blog")} target="_blank"><img className="footer-nav__social__icon" src={`${prefix}/assets/social/blog.svg`}/></a>
                        </li>
                        <li className="footer-nav__links">
                            <a href="https://www.autodesk.com/company/legal-notices-trademarks" onClick={() => this.sendGoogleGA("legal")} target="_blank">Legal</a>
                            <a href="https://forums.autodesk.com/t5/eagle-forum/bd-p/3500" onClick={() => this.sendGoogleGA("forum")} target="_blank">Forums</a>
                            <a href="https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement">Privacy</a>
                            <a data-opt-in-preferences href="javascript:;" id="adsk-eprivacy-privacy-settings-footer-link">Cookie preferences</a>
                            <a data-wat-linkname="manage-ccpa-settings-footer-link" href="https://www.autodesk.com/company/legal-notices-trademarks/ccpa-do-not-sell">Do not sell or share my personal information</a>
                        </li>
                    </ul>
                </div>
            </footer>
        );
    };
}

module.exports = Footer;
